import React from 'react'
import GradeA from '../../../assets/images/grade-a.webp'
import GradeB from '../../../assets/images/grade-b.webp'
import GradeC from '../../../assets/images/grade-c.webp'
import GradeD from '../../../assets/images/grade-d.webp'
import CurvedSurface from '../../../assets/images/curved-surface.png'
import Text from '../../atoms/Text'

const GRADE_IMG_TEXT_MAPPING = {
  A: {
    imgSrc: GradeA,
    text: 'Your food is safe to consume',
  },
  B: {
    imgSrc: GradeB,
    text: 'Your food is safe to consume',
  },
  C: {
    imgSrc: GradeC,
    text: 'Reduce food quantity or avoid if possible',
  },
  D: {
    imgSrc: GradeD,
    text: 'Avoid this food',
  },
}

const Grade = ({ grade = 'A' }) => {
  return (
    <div className="mt-4">
      <img
        src={GRADE_IMG_TEXT_MAPPING[grade].imgSrc}
        alt={grade}
        className="w-full h-auto px-12"
      />
      <div className="relative flex flex-col items-center -mt-[110px]">
        <img src={CurvedSurface} alt="curve" className="w-full h-auto" />
        <Text
          tag={'p'}
          variant={'headline'}
          size={'large'}
          textalign={'center'}
          className={'text-text-primary px-4 absolute bottom-[15%] z-10'}
        >
          {GRADE_IMG_TEXT_MAPPING[grade].text}
        </Text>
      </div>
    </div>
  )
}

export default Grade
